import {Rating} from "../../entities/rating";
import {BusinessException, BusinessRuleException} from "../../exceptions/exceptions";
import {ContentAnnotation, ContentDoubt} from "../../../infrastructure/presentation/views/content/helpers";

/** Check rating is valid */
export const processRating = (rating: Rating): void => {
  const errors: BusinessException[] = [];
  if (rating.stars <= 0 || rating.stars > 5) {
    errors.push(new BusinessException("Selecione entre uma e cinco estrelas.", "INVALID_RATING"))
  }

  if (rating.stars < 4 && !rating.message.trim()) {
    errors.push(new BusinessException("Deixe uma mensagem", "INVALID_RATING"))
  }

  if (errors.length) {
    throw new BusinessRuleException(errors);
  }
}

/** Check doubt is valid */
export const processDoubt = (contentDoubt: ContentDoubt): void => {
  const errors: BusinessException[] = [];
  if (!contentDoubt.title.trim()) {
    errors.push(new BusinessException("Informe o título da dúvida", "INVALID_CONTENT_DOUBT"))
  }

  if (!contentDoubt.description.trim()) {
    errors.push(new BusinessException("Informe a descrição da dúvida", "INVALID_CONTENT_DOUBT"))
  }

  if (errors.length) {
    throw new BusinessRuleException(errors);
  }
}

/** Check annotation is valid */
export const processAnnotation = (annotation: ContentAnnotation): void => {
  const errors: BusinessException[] = [];
  if (!annotation.text.trim()) {
    errors.push(new BusinessException("Informe o texto da anotação", "INVALID_CONTENT_ANNOTATION"))
  }

  if (errors.length) {
    throw new BusinessRuleException(errors);
  }
}

export const processProgressSpeedRate = (speedRate: number): void => {
  const errors: BusinessException[] = [];
  if (speedRate <= 0 || speedRate > 2) {
    errors.push(new BusinessException("Velocidade de reprodução inválida.", "INVALID_SPEED_RATE"))
  }

  if (errors.length) {
    throw new BusinessRuleException(errors);
  }
}

export const processCheckpointTimestamp = (timestamp: number): void => {
  const errors: BusinessException[] = [];
  if (timestamp < 0) {
    errors.push(new BusinessException("Checkpoint inválido.", "INVALID_CHECKPOINT"))
  }

  if (errors.length) {
    throw new BusinessRuleException(errors);
  }
}